import React, { useState } from "react";
import RoleContext from "./Index.jsx";
import { alertToastErrorFromResponse } from "../../../Shared/Utils/errorUtils";

import { alertSuccess } from "../../../Shared/Utils/alertMessages.js";
import {
  errorDeleteingData,
  errorGettingData,
  errorInsertingData,
  errorUpdatingData,
  ItemCreated,
  ItemUpdated,
  successDeleted,
} from "../../../Shared/Constants";

import { getCall } from "../../../Shared/Api/GetApi.js";
import { postCall } from "../../../Shared/Api/PostApi.js";
import { putCall } from "../../../Shared/Api/PutApi.js";
import { deleteCall } from "../../../Shared/Api/DeleteApi.js";
import { RolesApi } from "../../../Shared/Constants/api.js";

export const RoleProvider = (props) => {
  const [currentRole, setCurrentRole] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [roles, setRoles] = useState([]);
  const [item, setItem] = useState([]);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [modal, setModal] = useState(false);
  const modalTogle = () => {
    setModal(!modal);
  };
  //List objects frokm db
  const fetchRoles = async (page, limit) => {
    setLoading(true);
    try {
      let response = await getCall(`${RolesApi}`, {
        search: searchTerm,
        page: page,
        limit: limit,
        //...filters,
      });
      let data = response.data;

      if (response.result === "success") {
        setRoles(data.items); // Append new data
        setTotalRows(data.totalRows); // Append new data
      } else {
        setRoles([]); // Append new data
        setTotalRows(0); // Append new data
        alertToastErrorFromResponse(errorGettingData, response);
      }
    } catch (error) {
      alertToastErrorFromResponse(errorGettingData, error);
    } finally {
      setLoading(false);
    }
  };

  //Create object
  const createItem = async (data) => {
    setSaving(true);
    let response = await postCall(`${RolesApi}`, data);

    if (response?.result && response?.result == "success") {
      alertSuccess(ItemCreated);
      modalTogle();
      fetchRoles(currentPage, rowsPerPage);
    } else {
      alertToastErrorFromResponse(errorInsertingData, response);
    }

    setSaving(false);
  };

  //edit item
  const updateItem = async (data, id) => {
    setSaving(true);
    let response = await putCall(`${RolesApi}/${id}`, data);

    if (response?.result && response?.result == "success") {
      fetchRoles(currentPage, rowsPerPage);
      alertSuccess(ItemUpdated);
      modalTogle();
    } else {
      alertToastErrorFromResponse(errorUpdatingData, response);
    }

    setSaving(false);
  };

  //delete item
  const deleteItem = async (id) => {
    setLoading(true);
    let response = await deleteCall(`${RolesApi}/${id}`);

    if (response?.result && response?.result == "success") {
      const newdata = roles.filter((elem) => {
        return id !== elem.id;
      });
      setRoles(newdata);
      alertSuccess(successDeleted);
    } else {
      alertToastErrorFromResponse(errorDeleteingData, response);
    }
    setLoading(false);
  };

  return (
    <RoleContext.Provider
      value={{
        ...props,

        currentRole,
        setCurrentRole,
        searchTerm,
        setSearchTerm,
        roles,
        setRoles,
        item,
        setItem,
        loading,
        setLoading,
        saving,
        setSaving,
        currentPage,
        setCurrentPage,
        rowsPerPage,
        setRowsPerPage,
        totalRows,
        setTotalRows,
        searchTerm,
        fetchRoles,
        createItem,
        updateItem,
        modal,
        setModal,
        setItem,
        modalTogle,
        deleteItem,
      }}
    >
      {props.children}
    </RoleContext.Provider>
  );
};

export default RoleProvider;
